var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedinOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.1 39",
    style: {
      enableBackground: "new 0 0 39.1 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#dd5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_115_27",
    transform: "translate(21.5 21.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(14.29 16.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M-12.2-22c3.3,0,6,2.7,6,6v7h-4v-7c0-1.1-0.9-2-2-2s-2,0.9-2,2v7h-4v-7C-18.2-19.3-15.6-22-12.2-22 z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect",
    x: -26.2,
    y: -21,
    className: "st0",
    width: 4,
    height: 12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Path-2",
    className: "st0",
    cx: -24.2,
    cy: -26,
    r: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedinOrange);
export default __webpack_public_path__ + "static/media/icon-Linkedin-orange.5809cda965040829cc2fd6d6154efa2d.svg";
export { ForwardRef as ReactComponent };